<template>
  <v-container>
    <h2>Company Config</h2>
    <v-card elevation="1" class="mt-2 pa-2">
      <v-card-text class="pt-1 pb-1">
        <v-row>
          <v-col cols="2">
            <v-btn color="primary" @click="openAddEditDialog()" block>
              <v-icon>mdi-plus</v-icon>Add Config
            </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn color="primary" @click="openAddEditOneFeieldDialog()" block>
              <v-icon>mdi-plus</v-icon>Add One Field
            </v-btn>
          </v-col>
          <v-col cols="3" offset="5" class="pr-3">
            <v-btn outlined color="info" block @click="updateDialog = true">
              <v-icon>mdi-arrow-expand-up</v-icon>Update Version
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card elevation="2" class="mt-4">
      <v-card-text class="pt-2 pb-2 pl-0 pr-0">
        <v-container fill-height fluid v-show="loading">
          <v-row align="center" justify="center" style="height: 80vh;">
            <v-progress-circular :size="80" color="primary" indeterminate></v-progress-circular>
          </v-row>
        </v-container>

        <v-container v-show="!loading" class="pa-0">
          <v-card
            v-for="item in globalConfigList"
            :key="item.company_id"
            class="mt-2 sae-hover pa-0"
            elevation="1"
          >
            <v-row @click="openAddEditDialog(true, item.company_id)" class="pl-2 pr-2 pb-2">
              <v-col class="pt-1 pb-1" md="3">
                <v-card-text class="pa-1">Company Name</v-card-text>
                <v-card-title class="pa-1 sae-font-1">{{item.company_name? item.company_name : '-'}}</v-card-title>
                <v-card-subtitle class="pa-1">{{item.company_id}}</v-card-subtitle>
              </v-col>
              <v-col class="pt-1 pb-1">
                <v-card-text class="pa-1">Android Version</v-card-text>
                <v-card-title
                  class="pa-1 sae-font-1"
                >{{getKeyValue(item.data, 'mobile_version', 'android_latest_version')}}</v-card-title>
                <v-card-subtitle
                  class="pa-1"
                >{{getKeyValue(item.data, 'mobile_version', 'android_min_version')}}</v-card-subtitle>
              </v-col>
              <v-col class="pt-1 pb-1">
                <v-card-text class="pa-1">Android Build</v-card-text>
                <v-card-title
                  class="pa-1 sae-font-1"
                >{{getKeyValue(item.data, 'mobile_version', 'android_latest_build')}}</v-card-title>
                <v-card-subtitle
                  class="pa-1"
                >{{getKeyValue(item.data, 'mobile_version', 'android_min_build')}}</v-card-subtitle>
              </v-col>
              <v-col class="pt-1 pb-1">
                <v-card-text class="pa-1">iOS Version</v-card-text>
                <v-card-title
                  class="pa-1 sae-font-1"
                >{{getKeyValue(item.data, 'mobile_version', 'ios_latest_version')}}</v-card-title>
                <v-card-subtitle
                  class="pa-1"
                >{{getKeyValue(item.data, 'mobile_version', 'ios_min_version')}}</v-card-subtitle>
              </v-col>
              <v-col class="pt-1 pb-1">
                <v-card-text class="pa-1">iOS Build</v-card-text>
                <v-card-title
                  class="pa-1 sae-font-1"
                >{{getKeyValue(item.data, 'mobile_version', 'ios_latest_build')}}</v-card-title>
                <v-card-subtitle
                  class="pa-1"
                >{{getKeyValue(item.data, 'mobile_version', 'ios_min_build')}}</v-card-subtitle>
              </v-col>
              <v-col class="pt-1 pb-1" md="3">
                <v-card-text class="pa-1">List Features</v-card-text>
                <v-chip
                  small
                  color="success"
                  v-show="getKeyValue(item.data, 'config_fr', 'face_check_in_type')"
                >
                  <v-icon left small class="pr-1 mr-0">mdi-checkbox-marked-circle</v-icon>FR Checkin
                </v-chip>

                <!-- <v-chip
                  small
                  color="primary"
                  v-show="getKeyValue(item.data, 'config_fr', 'face_check_in_type')"
                >
                  <v-icon left small class="pr-1 mr-0">mdi-checkbox-marked-circle</v-icon>Record
                </v-chip>-->

                <v-chip
                  small
                  color="primary"
                  v-show="getKeyValue(item.data, 'feature_overtime', 'is_enabled')"
                >
                  <v-icon left small class="pr-1 mr-0">mdi-checkbox-marked-circle</v-icon>Overtime
                </v-chip>

                <v-chip
                  small
                  color="primary"
                  v-show="getKeyValue(item.data, 'feature_activity', 'is_enabled')"
                >
                  <v-icon left small class="pr-1 mr-0">mdi-checkbox-marked-circle</v-icon>Activity
                </v-chip>

                <v-chip
                  small
                  color="primary"
                  v-show="getKeyValue(item.data, 'feature_leave', 'is_enabled')"
                >
                  <v-icon left small class="pr-1 mr-0">mdi-checkbox-marked-circle</v-icon>Leave
                </v-chip>

                <v-chip
                  small
                  color="primary"
                  v-show="getKeyValue(item.data, 'feature_correction', 'is_enabled')"
                >
                  <v-icon left small class="pr-1 mr-0">mdi-checkbox-marked-circle</v-icon>Correction
                </v-chip>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- Dialog Container for Viewer Global Config -->
    <v-container class="pb-0">
      <v-dialog v-model="addEditdialog" persistent max-width="900">
        <v-card class="pa-3" ref="topView">
          <v-card-title class="headline w-100">
            <v-row>
              <v-col>{{isEdit ? 'View' : 'Add New'}} Configuration</v-col>
              <v-col>
                <v-btn icon class="float-right" @click="addEditdialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <div>
              <v-row>
                <v-col md="6" v-if="!isEdit">
                  <v-autocomplete
                    v-model="selectedCompany"
                    :items="companyList"
                    color="white"
                    hide-no-data
                    hide-selected
                    item-text="name_company"
                    item-value="id"
                    placeholder="Find Company"
                    append-icon="mdi-plus"
                  ></v-autocomplete>
                </v-col>
                <v-col md="6" v-if="isEdit">
                  <v-text-field v-model="selectedCompany" label="Company Id" disabled></v-text-field>
                </v-col>

                <v-col md="6" v-if="isAddOneField">
                  <v-switch label="Apply To All" class="my-0 py-0" v-model="applyToAll"></v-switch>
                </v-col>
              </v-row>
            </div>
            <div>
              <v-list elevation="1">
                <v-list-group v-for="(item,i) in listDataItem" v-bind:key="i" class="pa-0">
                  <template v-slot:activator>
                    <v-list-item-title>{{item.name}}</v-list-item-title>
                  </template>
                  <template v-slot:appendIcon>
                    <v-tooltip top v-if="i == 0">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="openMainKeyDialog()" v-bind="attrs" v-on="on">
                          <v-icon color="primary" class="sae-notranslate">mdi-plus-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Add Key Feature</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="openPayrollAccessControl"
                          icon
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          v-show="checkShowPAC(item)"
                        >
                          <img
                            class="mdi-settings"
                            width="18"
                            height="18"
                            src="/img/ic_settings.svg"
                          />
                        </v-btn>
                      </template>
                      <span>Payroll Access Control</span>
                    </v-tooltip>

                    <!-- <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          @click="openMainKeyDialog(true, item, i)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon class="sae-notranslate">mdi-pencil-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Edit Key Feature</span>
                    </v-tooltip>-->

                    <v-tooltip top v-if="listDataItem.length != 1">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon @click="removeMainKey(i)" v-bind="attrs" v-on="on">
                          <v-icon color="error" class="sae-notranslate">mdi-delete-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Remove Key Feature</span>
                    </v-tooltip>

                    <v-icon>mdi-chevron-down</v-icon>
                  </template>

                  <v-list-item-title
                    v-for="(child,j) in item.children"
                    v-bind:key="j"
                    class="ml-5 mr-5 pt-2"
                  >
                    <v-card class="sae-hover">
                      <v-card-text class="pa-1">
                        <v-row>
                          <v-col md="3">{{child.key}}</v-col>
                          <v-col md="3">{{child.type}}</v-col>
                          <v-col md="3">{{child.value}}</v-col>
                          <v-col md="3" class="text-right">
                            <v-tooltip top v-if="j == 0">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  @click="openSubKeyDialog(false, {}, i, j)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon color="primary" small>mdi-plus</v-icon>
                                </v-btn>
                              </template>
                              <span>Add Key Value</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  @click="openSubKeyDialog(true, child, i, j)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                              </template>
                              <span>Edit Key Value</span>
                            </v-tooltip>

                            <v-tooltip top v-if="item.children.length != 1">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon @click="removeSubKey(i,j)" v-bind="attrs" v-on="on">
                                  <v-icon color="error" small class="sae-notranslate">mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Remove Key Value</span>
                            </v-tooltip>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-list-item-title>
                </v-list-group>
              </v-list>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="addEditdialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="saveLoading" @click="updateConfig()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <!-- Dialog Container for Viewer Global Config -->

    <!-- Main Key -->
    <v-container class="pb-0">
      <v-dialog v-model="mainKeyDialog" persistent max-width="800">
        <v-card class="pa-3">
          <v-card-title class="headline w-100">
            <v-row>
              <v-col>{{isEditKey ? 'Edit' : 'Add New'}} Key Feature</v-col>
              <v-col>
                <v-btn icon class="float-right" @click="mainKeyDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-combobox clearable v-model="mainKeyData.name" :items="mainKeyItem" chips></v-combobox>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="mainKeyDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="saveLoading" @click="saveMainKey()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Sub Key -->
    <v-container class="pb-0">
      <v-dialog v-model="subKeyDialog" persistent max-width="800">
        <v-card class="pa-3">
          <v-card-title class="headline w-100">
            <v-row>
              <v-col>{{isEditKey ? 'Edit' : 'Add New'}} Key Value</v-col>
              <v-col>
                <v-btn icon class="float-right" @click="subKeyDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-card>
              <v-row>
                <v-col md="4" class="pt-0 pb-0">
                  <v-text-field
                    class="ml-2"
                    hide-details
                    label="Key"
                    single-line
                    v-model="subKeyData.key"
                  ></v-text-field>
                </v-col>
                <v-col md="4" class="pt-0 pb-0">
                  <v-select
                    :items="typeData"
                    placeholder="Type"
                    v-model="subKeyData.type"
                    item-text="text"
                    item-value="id"
                  ></v-select>
                </v-col>
                <v-col md="4" class="pt-0 pb-0">
                  <v-text-field
                    v-if="subKeyData.type != 'boolean'"
                    hide-details
                    label="Value"
                    single-line
                    v-model="subKeyData.value"
                    :type="subKeyData.type"
                  ></v-text-field>
                  <v-select
                    v-if="subKeyData.type == 'boolean'"
                    :items="[true, false]"
                    placeholder="Value"
                    v-model="subKeyData.value"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" text @click="subKeyDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="saveLoading" @click="saveSubKey()">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Apply to All Dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Apply To All</v-card-title>
        <v-card-text>Are you sure want apply to All?</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="confirmDialog = false">Cancel</v-btn>
          <!-- <v-btn color="error" @click="sendUpdate()">Update</v-btn> -->
          <v-btn
            color="error"
            @click="saveForm(listDataItem, selectedCompany, isEdit, applyToAll)"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Update Version -->
    <v-dialog v-model="updateDialog" max-width="900">
      <v-stepper v-model="updateStep" vertical>
        <v-stepper-step :complete="updateStep > 1" step="1">
          Select a company to update
          <small>Select multiple if needed</small>
        </v-stepper-step>
        <v-stepper-content step="1">
          <v-card class="pa-0 mt-0 elevation-0">
            <v-card-text class="mt-0 pt-0">
              <v-btn text x-small color="primary" @click="selectAllCompanies()">
                <v-icon left>mdi-check-circle-outline</v-icon>Select All
              </v-btn>
              <v-btn text x-small color="primary" @click="deselectAllCompanies()">
                <v-icon left>mdi-checkbox-blank-circle-outline</v-icon>Deselect All
              </v-btn>
              <v-row>
                <div v-for="company in tmpAllCompanyList" :key="company.id" class="col-3">
                  <v-checkbox
                    class="shrink"
                    v-model="selectedCompaniesToUpdate"
                    :label="company.name_company"
                    :value="company.id"
                    hide-details
                  ></v-checkbox>
                </div>
              </v-row>
            </v-card-text>
          </v-card>
          <v-btn color="primary" @click="updateStep = 2">Continue</v-btn>
          <v-btn text @click="resetUpdate">Cancel</v-btn>
        </v-stepper-content>
        <v-stepper-step :complete="updateStep > 2" step="2">Set version number to update to</v-stepper-step>
        <v-stepper-content step="2">
          <v-list-item-content>
            <span class="subtitle-1">Android</span>
          </v-list-item-content>
          <v-row>
            <v-col md="3" class="ma-0">
              <v-text-field label="App Latest" v-model="updateData.android_latest_version" outlined></v-text-field>
            </v-col>
            <v-col md="3" class="ma-0">
              <v-text-field label="App Minimum" v-model="updateData.android_min_version" outlined></v-text-field>
            </v-col>
            <v-col md="3" class="ma-0">
              <v-text-field
                label="Build Latest"
                v-model="updateData.android_latest_build"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col md="3" class="ma-0">
              <v-text-field
                label="Build Minimum"
                v-model="updateData.android_min_build"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-list-item-content>
            <span class="subtitle-1">iOS</span>
          </v-list-item-content>
          <v-row>
            <v-col md="3" class="ma-0">
              <v-text-field label="App Latest" v-model="updateData.ios_latest_version" outlined></v-text-field>
            </v-col>
            <v-col md="3" class="ma-0">
              <v-text-field label="App Minimum" v-model="updateData.ios_min_version" outlined></v-text-field>
            </v-col>
            <v-col md="3" class="ma-0">
              <v-text-field
                label="Build Latest"
                v-model="updateData.ios_latest_build"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
            <v-col md="3" class="ma-0">
              <v-text-field
                label="Build Minimum"
                v-model="updateData.ios_min_build"
                type="number"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn color="primary" @click="updateStep = 3">Continue</v-btn>
          <v-btn text @click="resetUpdate">Cancel</v-btn>
        </v-stepper-content>
        <v-stepper-step :complete="updateStep > 3" step="3">
          Review update
          <small>Press run to execute or reset to start over</small>
        </v-stepper-step>
        <v-stepper-content step="3">
          <v-card color="grey lighten-3" class="pa-3 mb-6">
            <div>
              Companies selected:
              <p>{{ selectedCompaniesToUpdate }}</p>
              <p>
                Android Version (Latest, Min):
                <span>{{ updateData.android_latest_version }}</span>
                &nbsp;
                <span>{{ updateData.android_min_version }}</span>
              </p>
              <p>
                Android Build (Latest, Min):
                <span>{{ updateData.android_latest_build }}</span>
                &nbsp;
                <span>{{ updateData.android_min_build }}</span>
              </p>
              <p>
                iOS Version (Latest, Min):
                <span>{{ updateData.ios_latest_version }}</span>
                &nbsp;
                <span>{{ updateData.ios_min_version }}</span>
              </p>
              <p>
                iOS Build (Latest, Min):
                <span>{{ updateData.ios_latest_build }}</span>
                &nbsp;
                <span>{{ updateData.ios_min_build }}</span>
              </p>
            </div>
            <v-card-actions>
              <v-btn color="primary" @click="runUpdate" :loading="updateExecuted">Run</v-btn>
              <v-btn
                text
                @click="updateStep = 1; updateData = {}; selectedCompaniesToUpdate = [];"
                v-show="!updateExecuted"
              >Reset</v-btn>
            </v-card-actions>
          </v-card>
          <v-row class="justify-end">
            <v-btn text @click="resetUpdate" v-show="updateExecuted" class="mr-3">Close</v-btn>
          </v-row>
        </v-stepper-content>
      </v-stepper>
    </v-dialog>
    <!-- End -->
  </v-container>
</template>

<script>
import firebase from "firebase";
import ENV from "./../../store/modules/environtment";

export default {
  name: 'CompanyConfig',
  data() {
    return {
      mainKeyDialog: false,
      subKeyDialog: false,
      isEditKey: false,
      baseUrl: this.$store.getters.baseUrl,
      mainKeyItem: this.$store.getters.gcGetAllKeys,
      listDataItem: [{ name: null, children: [{ key: null, type: 'text', value: null }] }],
      typeData: [
        { id: 'text', text: 'Text' },
        { id: 'number', text: 'Number' },
        { id: 'boolean', text: 'Boolean' },
      ],
      alert: { show: false, type: '', msg: '', },
      dialog: false,
      loading: true,
      globalConfigList: [],
      companyList: [],
      addEditdialog: false,
      addingData: {},
      editingData: {},
      tmpAllCompanyList: [],
      tmpAvailableCompanyList: [],
      isEdit: false,
      isAddOneField: false,
      applyToAll: false,
      selectedCompany: null,
      selectedCompanyName: null,
      saveLoading: false,
      mainKeyData: {},
      subKeyData: {},
      mainIndex: null,
      subIndex: null,
      confirmDialog: false,
      updateDialog: false,
      updateExecuted: false,
      updateData: {
        android_min_version: '2.5.0',
        android_latest_version: '2.5.0',
        android_min_build: 52,
        android_latest_build: 52,
        ios_min_version: '2.5.0',
        ios_latest_version: '2.5.0',
        ios_min_build: 52,
        ios_latest_build: 52,
      },
      updateStep: 1,
      selectedCompaniesToUpdate: [],
    }
  },
  methods: {
    checkShowPAC(item) {
      let show = false
      if (item.name == 'feature_payroll') {
        show = item.children.find(e => {
          if (e.key == 'is_enabled') {
            if (e.value == true) return true
          }
        })
      }
      if (show && this.isEditable == true) return true
      return false
    },
    changeSelectedCompany(companyId) {
      if (companyId == 'default') {
        this.selectedCompanyName = null
      } else {
        const i = this.tmpAllCompanyList.map((item) => { return item.id }).indexOf(companyId)
        this.selectedCompanyName = this.tmpAllCompanyList[i].name_company
      }
    },
    openPayrollAccessControl() {
      if (this.selectedCompanyName) {
        this.$store.dispatch('setCompanyId', this.selectedCompany)
        this.$store.dispatch('setCompanyName', this.selectedCompanyName)
        this.$router.push('/payroll-access-control')
      } else {
        this.showMessage('warning', 'Selected company not configurable')
      }
    },
    updateConfig() {
      if (this.applyToAll) {
        this.confirmDialog = true
      } else {
        if (this.selectedCompany != null) {
          this.saveForm(this.listDataItem, this.selectedCompany, this.isEdit, this.applyToAll)
        } else {
          this.showMessage('warning', 'Please select any company')
        }
      }
    },
    openMainKeyDialog(isEdit = false, data = {}, i = null) {
      this.isEditKey = isEdit
      this.mainKeyDialog = true

      if (isEdit) {
        this.mainKeyData = Object.assign({}, data)
        this.mainIndex = i
      } else {
        this.mainKeyData = {
          name: '',
          children: [{ key: 'is_enabled', type: 'boolean', value: true }]
        }
      }
    },
    openSubKeyDialog(isEdit = false, data = {}, i = null, j = null) {
      this.isEditKey = isEdit
      this.subKeyDialog = true
      this.mainIndex = i
      if (isEdit) {
        this.subKeyData = Object.assign({}, data)
        this.subIndex = j
      } else {
        this.subKeyData = { key: '', type: 'boolean', value: true }
      }
    },
    saveMainKey() {
      if (this.isEditKey) {
        this.listDataItem[this.mainIndex] = this.mainKeyData
      } else {
        this.listDataItem.unshift(this.mainKeyData)
      }
      this.mainKeyDialog = false
    },
    saveSubKey() {
      if (this.isEditKey) {
        this.listDataItem[this.mainIndex].children[this.subIndex] = this.subKeyData
      } else {
        this.listDataItem[this.mainIndex].children.unshift(this.subKeyData)
      }
      this.subKeyDialog = false
    },
    removeMainKey(i) {
      if (this.listDataItem.length > 1) {
        setTimeout(() => {
          this.listDataItem.splice(i, 1)
        }, 500);
      }
    },
    removeSubKey(i, j) {
      if (this.listDataItem[i].children.length > 1) {
        setTimeout(() => {
          this.listDataItem[i].children.splice(j, 1)
        }, 500);
      }
    },
    close(event) {
      this.alert.show = event
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', { type, msg })
    },
    async saveForm(data, selectedCompany, isEdit, applyToAll) {
      this.saveLoading = true
      const config = this.mappingFirebaseDataReverse(data)
      const body = {
        companyId: selectedCompany,
        applyToAll,
        config
      }
      let result
      switch (true) {
        case (isEdit == true):
          result = await this.$store.dispatch('saveGlobalConfigMerge', body)
          break;
        case (this.isAddOneField == true):
          result = await this.$store.dispatch('editGlobalConfig', body)
          break;

        default:
          result = await this.$store.dispatch('saveGlobalConfig', body)
          break;
      }
      if (result) {
        this.showMessage('success', `Data ${isEdit ? 'Updated' : 'Saved'}`)
        this.addEditdialog = false
      }
      this.saveLoading = false;
      this.refreshData()
      this.loading = true;
      this.confirmDialog = false
    },
    async getCompanies() {
      return await this.$store.dispatch('getCompanyList')
    },
    getConfig() {
      return new Promise(async (resolve) => {
        this.globalConfigList = [];
        let temp = []
        const result = await firebase.firestore().collection(ENV.firebase.globalConfig).get()
        if (result) {
          result.docs.map((company) => {
            let row = { company_name: null, company_id: company.id, data: company.data(), selected: true, }
            this.globalConfigList.push(row);
            temp.push(row)
          });
          this.loading = false;
          resolve(temp)
        }

      })
    },
    getDefaultConfig() {
      return new Promise(async (resolve, reject) => {
        try {
          const result = await firebase.firestore().collection(ENV.firebase.globalConfig).doc("default").get();
          if (result) return resolve(result.data())
          reject(new Error('Fail To Load'))
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e.message)
          reject(new Error('Connection Error'))
        }
      })
    },
    getKeyValue(data, feature, key) {
      if (data) if (data[feature]) if (data[feature][key]) return data[feature][key]
      return null
    },
    initData() {
      this.addingData = this.$store.getters.gcGetAll
      this.editingData = this.$store.getters.gcGetAll
    },
    async refreshData() {
      const companyList = await this.getCompanies();
      const companyConfig = await this.getConfig();
      const firstMap = await this.mappingCompany(companyList, companyConfig)
      this.doubleCheckConfig(firstMap)
    },
    mappingCompany(companyList = [], companyConfig) {
      return new Promise(async resolve => {
        let indexToDelete = []
        await Promise.all(companyConfig.map(data => {
          const i = companyList.map((item) => { return item.id }).indexOf(data.company_id);
          if (i >= 0) {
            data.company_name = companyList[i].name_company
            if (companyList[i].name_company != 'Default Company') indexToDelete.push(i)
          }
        }))
        this.tmpAllCompanyList = []
        setTimeout(() => {
          indexToDelete = indexToDelete.sort((a, b) => { return b - a });
          indexToDelete.map(i => {
            this.tmpAllCompanyList.push(companyList[i])
            companyList.splice(i, 1)
          })
        }, 200);
        resolve(companyList)
      })
    },
    doubleCheckConfig(company) {
      this.tmpAvailableCompanyList = company
      // company.map(data => {
      //   this.getCompanyConfig(data, true)
      // })
    },
    getCompanyConfigPromise(company) {
      return new Promise(async (resolve) => {
        const company_id = company
        firebase
          .firestore()
          .collection(ENV.firebase.globalConfig)
          .doc(company_id)
          .get()
          .then((doc) => {
            resolve(doc.data())
          })
      })
    },
    getCompanyConfig(company, loop = false) {
      const company_id = loop ? company.id : company
      firebase
        .firestore()
        .collection(ENV.firebase.globalConfig)
        .doc(company_id)
        .get()
        .then((doc) => {
          if (!loop) {
            this.editingData = doc.data();
            this.drawerLoading = false;
          } else {
            if (!doc.data()) {
              this.tmpAvailableCompanyList.push(company)
              this.companyList.push(company)
            } else {
              this.tmpAllCompanyList.push(company)
            }
          }
        });
    },
    async openAddEditDialog(isEdit = false, selectedCompany = null) {
      this.isAddOneField = false
      this.selectedCompany = selectedCompany
      this.applyToAll = false
      this.isEdit = isEdit
      this.companyList = this.tmpAvailableCompanyList
      this.loading = true
      if (isEdit) {
        this.changeSelectedCompany(selectedCompany)
        const config = await this.getCompanyConfigPromise(this.selectedCompany)
        this.listDataItem = this.mappingFirebaseData(config)
      } else {
        const default_config = await this.getDefaultConfig()
        this.listDataItem = this.mappingFirebaseData(default_config)
      }
      this.loading = false
      this.addEditdialog = true
      setTimeout(() => {
        this.$refs.topView.$el.scrollIntoView({ behavior: 'smooth' })
      }, 500);
    },
    mappingFirebaseData(config) {
      const expectedResult = []
      const keyFirebase = Object.keys(config)
      keyFirebase.map((name) => {
        const data = { name, children: [] }
        const keyItem = Object.keys(config[name])
        keyItem.map(key => {
          const type = typeof config[name][key]
          data.children.push({ key, type: type == 'string' ? 'text' : type, value: config[name][key] })
        })
        expectedResult.push(data)
      })
      return expectedResult
    },
    mappingFirebaseDataReverse(data) {
      const firebaseData = {}
      data.map(item => {
        firebaseData[item.name] = {}
        item.children.map(child => {
          if (child.type == 'number') {
            firebaseData[item.name][child.key] = +(child.value)
          } else {
            firebaseData[item.name][child.key] = child.value
          }
        })
      })
      return firebaseData
    },
    async openAddEditOneFeieldDialog() {
      this.isAddOneField = true
      this.applyToAll = false
      this.isEdit = false
      this.listDataItem = []
      this.companyList = this.tmpAllCompanyList
      this.addEditdialog = true
      setTimeout(() => {
        this.openMainKeyDialog()
      }, 500);
    },
    selectAllCompanies() {
      this.selectedCompaniesToUpdate = []
      this.tmpAllCompanyList.forEach((company) => {
        this.selectedCompaniesToUpdate.push(company.id)
      })
    },
    deselectAllCompanies() {
      this.selectedCompaniesToUpdate = []
    },
    resetUpdate() {
      this.selectedCompaniesToUpdate = []
      this.updateStep = 1
      this.updateData = {}
      this.updateExecuted = false
      this.updateDialog = false
    },
    runUpdate() {
      let batch = firebase.firestore().batch();
      this.updateData.android_min_build = parseInt(this.updateData.android_min_build)
      this.updateData.android_latest_build = parseInt(this.updateData.android_latest_build)
      this.updateData.ios_min_build = parseInt(this.updateData.ios_min_build)
      this.updateData.ios_latest_build = parseInt(this.updateData.ios_latest_build)

      if (this.selectedCompaniesToUpdate.length > 0) {
        this.updateExecuted = true;
        this.selectedCompaniesToUpdate.forEach((company) => {
          const updateRef = firebase
            .firestore()
            .collection(ENV.firebase.globalConfig)
            .doc(company)
          batch.update(updateRef, { mobile_version: this.updateData })
        });

        batch.commit().then(() => {
          this.showMessage('success', 'Version Updated')
          this.updateExecuted = false;
          this.updateDialog = false
          this.refreshData()
        }).catch((err) => {
          this.updateExecuted = false;
          this.showMessage('error', 'Something went wrong')
          // eslint-disable-next-line no-console
          console.error(err);
        });
      } else {
        this.showMessage('warning', 'No Company Selected')
      }
    },
  },
  computed: {
    isEditable() {
      return this.isEdit
    }
  },
  async created() {
    this.initData()
    this.refreshData()
  }
}
</script>
<style scoped>
.sae-hover:hover {
  cursor: pointer;
  -webkit-box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%) !important;
}
.sae-notranslate {
  transform: none !important;
}
.sae-font-1 {
  font-size: 1rem !important;
}
</style>